/**
 * Mobile navigation drawer.
 *
 * The button and drawer only come alive once this script has run and stamped
 * [data-nav-ready] on the document. With scripting off, the inline nav stays
 * visible and every link is reachable — navigation that needs JavaScript to
 * exist is a site with no navigation.
 *
 * The drawer uses the hidden attribute rather than a display class, so it is
 * removed from the accessibility tree when closed and screen readers never
 * announce a menu that is not on screen.
 */
(function () {
  var drawer = document.getElementById('site-drawer');
  var openButton = document.querySelector('[data-menu-open]');
  var closeButton = document.querySelector('[data-menu-close]');
  if (!drawer || !openButton) return;

  document.documentElement.setAttribute('data-nav-ready', '');

  var lastFocused = null;

  function open() {
    lastFocused = document.activeElement;
    drawer.hidden = false;
    openButton.setAttribute('aria-expanded', 'true');
    document.documentElement.setAttribute('data-drawer-open', '');
    if (closeButton) closeButton.focus();
  }

  function close() {
    drawer.hidden = true;
    openButton.setAttribute('aria-expanded', 'false');
    document.documentElement.removeAttribute('data-drawer-open');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  openButton.addEventListener('click', open);
  if (closeButton) closeButton.addEventListener('click', close);

  // Escape closes it. Expected of anything that covers the page.
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !drawer.hidden) close();
  });

  // Following a link should not leave the drawer open behind the new page,
  // which matters for in-page anchors where no navigation actually happens.
  drawer.addEventListener('click', function (event) {
    if (event.target.closest('a')) close();
  });

  /*
   * Keep focus inside the drawer while it covers the page. Without this, tab
   * walks into the page behind and the focus ring vanishes off-screen.
   */
  drawer.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;

    var focusable = drawer.querySelectorAll('a[href], button:not([disabled])');
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  // A drawer left open across a resize to desktop would sit over the layout.
  var desktop = window.matchMedia('(min-width: 60rem)');
  var onChange = function (event) {
    if (event.matches && !drawer.hidden) close();
  };
  if (desktop.addEventListener) desktop.addEventListener('change', onChange);
})();
